<template>
    <v-container fluid class="no-border-container">
      <div :class="paginatedItems.length === 7 ? 'table_area_box' : 'table_area_box_empty'">
        <v-card-text>
            <div class="stock-status">
                <h4>Stock Status</h4>
                
                <div class="search-bar">
                    <div class="label-wrapper">
                        <label >Grower Outturn</label>
                      </div>
                      <input type="text" placeholder="Search Grower Outturn" class="custom-label">
                    <input type="date" value="2024-01-01">
                    <input type="date" value="2024-01-31">
                    <button class="btn search-btn">Search</button>
                <button class="btn download-btn">Download</button>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Cherry</th>
                            <th>Grower Outturn</th>
                            <th>Parchment Outturn</th>
                            <th>Clean Coffee</th>
                            <th>Grade</th>
                            <th>Warrant Number</th>
                            <th>Broker Outturn</th>
                            <th>Lot No</th>
                            <th>Amount</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>22-02-2024 11:34:39 AM</td>
                            <td>ID: 001 300Kg</td>
                            <td>11MU1001 55Kg</td>
                            <td>11MU2001 100Kg</td>
                            <td>11MU2001 90Kg</td>
                            <td>AA</td>
                            <td>WX112</td>
                            <td>11MU2001 45Kg</td>
                            <td>1123</td>
                            <td>$2000</td>
                            <td class="status-paid">PAID</td>
                            <td><button class="action-button" @click="goToStock">View</button></td>
                        </tr>
                        <tr>
                            <td>22-02-2024 11:34:39 AM</td>
                            <td>ID: 001 300Kg</td>
                            <td>11MU1001 55Kg</td>
                            <td>11MU2001 100Kg</td>
                            <td>11MU2001 90Kg</td>
                            <td>AA</td>
                            <td>WX112</td>
                            <td>11MU2001 45Kg</td>
                            <td>1123</td>
                            <td>$2000</td>
                            <td class="status-paid">PAID</td>
                            <td><button class="action-button">View</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </v-card-text>
        <v-card-actions>
          <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
          <v-spacer></v-spacer>
          <v-pagination
            v-model="page"
            :length="numberOfLinks"
            :total-visible="7"
            color="secondary"
                class="accent--text logoutbtn"
          ></v-pagination>
        </v-card-actions>
      </div>
    </v-container>
  </template>
  <script>
  import axios from 'axios'
  import config from '../../../config'
  import store from '../../../store'
  import * as XLSX from 'xlsx';
  export default {
      name: 'StockDetailStatusTracker',
      data: function () {
          return {
              tab: null,
              searchQuery: '',
            fromDate: '',
            toDate: '',
            items: [
            {
                id: 1,
                date: '22-02-2024 11:34:39 AM',
                cherry: 'ID: 001 300Kg',
                growerOutturn: '11MU1001 55Kg',
                parchmentOutturn: '11MU2001 100Kg',
                cleanCoffee: '11MU2001 90Kg',
                grade: 'AA',
                warrantNumber: 'WX112',
                brokerOutturn: '11MU2001 45Kg',
                lotNo: '1123',
                amount: '$2000',
                status: 'PAID'
            },
            ],
              message: '',
              loading: false,
              snackbar: false,
              snackbarColor: '',
              messsage: '',
              paginatedItems: [],
              permissions: [],
              numberOfLinks: 0,
              numberOfItemsPerPage: 7,
              currentPage: 0,
              page: 1
          }
      },
  //     components: {
  //   GrowerStockStatusDetail
  // },
      watch: {
          items: function () {
              this.paginatedItems = this.items
          },
          page: function (val) {
              this.paginatedItems = this.getLoanRequests(val - 1)
          }
      },
      computed: {
      filteredItems() {
        return this.items.filter(item => {
          return item.growerOutturn.includes(this.searchQuery);
        });
      }
    },
      mounted () {
          this.getLoanRequests(this.currentPage)
  
          this.permissions = store.state.user.roleId.permissions
      },
      methods: {
          hasPerm (permission) {
              return this.permissions.includes(permission)
          },
          search() {
        // Perform search
      },
      goToStock() {
      this.$router.push('/grower/stock/001');
    },
      download() {
        // Handle download
      },
      view(item) {
        // Handle view action
        console.log('Viewing item', item);
      }
      }
  }
  
  </script>
  <style scoped>
  .search-section {
    margin: 20px 0;
    padding: 10px;
  }
  
  .search-bar {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .search-bar input {
    padding: 5px;
  }
  .table_area_box_empty {
    position: relative;
    background: #fff;
    overflow-x: auto;
    /* //border: 1px solid #707070; */
  }
  
  .table_area_box {
    position: relative;
    background: #fff;
    overflow-x: auto;
  /* //border: 1px solid #707070; */
    
  }
  
  .thead {
    background-color: #00513B !important;
    color: white;
    font-size: 12px;
  }
  
  .table tbody tr > td.actions {
    font-size: 20px !important;
    color: #733D29 !important;
    padding-top: 0px;
  }
  
  .pagination {
    background-color: red;
  }
  
  .paginationtext {
    color: #733D29;
  }
  
  .pagination > li > a,
  .pagination > li > span {
    border: 1px solid #F2D0A7;
    color: #733D29;
  }
  
  .pagination > li.active > .page-link {
    background: #00513B;
    color: #fff;
  }
  
  .table {
    overflow-x: auto;
  }
  
  td {
    max-width: 200px; /* Set a maximum width for cells */
    overflow: hidden;
    text-overflow: ellipsis; /* Show ellipsis (...) for text overflow */
    white-space: nowrap; /* Prevent text from wrapping */
  
  }

  /*
  search
  */
  .content {
    margin-left: 270px;
    padding: 20px;
}
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.header h1 {
    color: #d32f2f;
    font-size: 28px;
}
.header img {
    border-radius: 50%;
    width: 50px;
}
.header .profile {
    display: flex;
    align-items: center;
}
.header .profile span {
    margin-right: 10px;
}
.stock-status {
    margin-top: 20px;
}
.stock-status h2 h3 {
    margin-bottom: 20px;
    font-size: 20px;
    color:  #00513B !important;
}
.stock-status .search-bar {
    display: flex;
    align-items: center;
    margin-bottom: 0px;
}
.stock-status .search-bar input, 
.stock-status .search-bar select {
    padding: 10px;
    margin-right: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
}
.stock-status .search-bar {
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}
.stock-status .search-bar button:hover {
    background-color: #2e7d32;
}
.stock-status table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}
.stock-status table th, .stock-status table td {
    border: 1px solid #ccc;
    padding: 10px;
    text-align: left;
}
.stock-status table th {
    background-color: #00513B !important;
    color: white;
    font-size: 12px;
}
.stock-status table tr:nth-child(even) {
    background-color: #f9f9f9;
}
.stock-status table .status-paid {
    color: green;
    font-weight: bold;
}
.stock-status table .action-button {
    padding: 5px 10px;
    background-color: #2e7d32;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}
.stock-status table .action-button:hover {
    background-color: #1b5e20;
}
td {
    word-wrap: break-word;
    word-break: break-all;
    white-space: normal;
    max-width: 100px;
    padding: 4px;
    border: 1px solid #ddd;
  }
  .search-bar {
    display: flex;
    justify-content: space-between;  
    gap: 20px;
}

.search-bar input,
.search-bar button {
     /* flex: 1; */
    max-width: 250px;
    border-radius: 15px 15px 15px 15px; 
}
.label-wrapper {
    display: flex;
    align-items: center;
    color: #272626;
    font-size: 16px;
  }
  
  .label-wrapper {
    margin-right: 0px; /* Adjust to ensure no gap between label and input */
  }
  
  .custom-label {
    background-color: #f0f0f0; /* Greyish background color */
    color: #333; /* Text color */
    padding: 10px 15px; /* Padding inside the label */
    border-radius: 15px 0 0 15px; /* Slightly curved on the left side */
    font-size: 16px; /* Font size */
    font-weight: bold; /* Optional: makes the text bold */
    display: inline-block; /* Allows the label to fit its content */
    white-space: nowrap; /* Prevents label from wrapping to the next line */
  }
  
  input[type="text"] {
    padding: 10px 15px; /* Padding inside the input */
    border: 1px solid #ccc; /* Border color */
    border-radius: 0 15px 15px 0; /* Slightly curved on the right side */
    font-size: 16px; /* Font size */
    box-sizing: border-box; /* Ensures padding and border are included in width calculation */
    outline: none; /* Removes the default focus outline */
  }
  .search-btn {
    background-color: #004d40;
    color: white;
  }
  
  .download-btn {
    background-color: #4CAF50;
    color: white;
  }
  </style>
  